import dynamic from 'next/dynamic';

const CarrouselFeaturedPackage = dynamic(() => import('./CarrouselFeaturedPackage'));

export default CarrouselFeaturedPackage;
